<template>
  <div>
    <Modal @closeModal="$emit('closeTriggered')">
      <!-- MODAL TITLE -->
      <div slot="modal-title">
        <span class="font-weight-bold">UPDATE TIMEZONE</span>
      </div>

      <!-- MODAL BODY -->
      <div slot="modal-body">
        <form action @submit.prevent="updateSchoolTimezone">
          <div
            class="font-14 color_grey_dark position-relative py-2"
            style="top: 5px; bottom: 25px"
          >Select your country's region and proceed to your country's timezone.</div>

          <!-- ERROR/SUCCESS ALERT -->
          <div style="position: relative; top: -20px; margin-bottom: -15px;">
            <AuthAlertCard v-if="show_alert" :alert_type="alert_type" :alert_msg="alert_msg"></AuthAlertCard>
          </div>

          <div class="container mt-4">
            <!-- REGION -->
            <div class="modal-body-row row">
              <label for class="text-uppercase control-label color_grey_dark">Select Country Region</label>
              <select
                v-model="form.region"
                class="form-control"
                @change="fetchTimezone(form.region)"
                required
              >
                <option selected disabled value>Select Region</option>
                <option
                  :value="region.slug"
                  v-for="(region, index) in regions"
                  :key="index"
                >{{ region.title }}</option>
              </select>
            </div>

            <!-- TIMEZONE -->
            <div class="modal-body-row row">
              <label for class="text-uppercase control-label color_grey_dark">Select Timezone</label>
              <select v-model="form.timezone" class="form-control" required>
                <option selected disabled value>Select Timezone</option>
                <option
                  :value="timezone.name"
                  v-for="(timezone, index) in timezones"
                  :key="index"
                >{{ timezone.name }}</option>
              </select>
            </div>
          </div>

          <!-- CANCEL OR SUBMIT FORM -->
          <div
            class="modal-body-row row d-flex justify-content-center align-items-center nowrap mb-2"
          >
            <button @click="dropModal" class="btn btn-md black-ic z-depth-0 mr-4">Cancel</button>
            <button type="submit" class="btn btn-md btn-accent ml-4" ref="updateBtn">Update</button>
          </div>
        </form>
      </div>
    </Modal>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import Modal from "@/components/globalComps/Modal";
import { setTimeout } from "timers";
// import { setTimeout } from "timers";

export default {
  name: "TimezonelModal",

  components: {
    Modal,
    AuthAlertCard: () =>
      import(/* webpackChunkName: "AuthAlertCard" */ "@/components/globalComps/AuthComps/AuthAlertCard")
  },
  data() {
    return {
      form: {
        region: "",
        timezone: ""
      },
      regions: [
        { title: "Africa", slug: "africa" },
        { title: "America", slug: "america" },
        { title: "Antartica", slug: "antartica" },
        { title: "Asia", slug: "asia" },
        { title: "Atlantic", slug: "atlantic" },
        { title: "Australia", slug: "australia" },
        { title: "Europe", slug: "europe" },
        { title: "Indian", slug: "indian" },
        { title: "Pacific", slug: "pacific" }
      ],
      timezones: [],
      account_type: null,
      show_alert: false,
      alert_type: null, //SET TO EITHER SUCCESS OR ERROR
      alert_msg: null
    };
  },

  computed: {},

  mounted() {
    this.getAccountType();
  },

  methods: {
    ...mapActions(["getTimezone", "updateTimezone"]),

    getAccountType() {
      this.account_type = this.$route.path.split("/")[1];
    },

    dropModal() {
      this.$emit("closeTriggered");
    },

    fetchTimezone(area) {
      this.timezones = [];
      this.getTimezone(area)
        .then(response => {
          response.data.map(timezone => {
            let time_zone = {};
            time_zone.name = timezone.name;
            this.timezones.push(time_zone);
          });
        })
        .catch(err => console.log(err));
    },

    updateSchoolTimezone() {
      this.$refs.updateBtn.disabled = true;
      this.$refs.updateBtn.innerHTML =
        '<div class="icon-dotted-roller font-17 mr-2 animate"></div>Please wait...';

      this.updateTimezone(this.form)
        .then(response => {
          if (response.code === 200) {
            setTimeout(() => {
              this.show_alert = false;

              this.$refs.updateBtn.disabled = true;
              this.$refs.updateBtn.innerHTML =
                '<div class="icon-accept font-18 mr-2"></div>Successful';
            }, 1000);

            setTimeout(() => {
              this.$emit("remountTimezone");
              let dialog_data = {
                msg: "Timezone updated successfully...",
                type: "success"
              };
              this.$emit("showAlertCard", dialog_data);
              this.dropModal();
            }, 2500);
          } else {
            setTimeout(() => {
              this.show_alert = true;
              this.alert_type = "error";
              this.alert_msg = "An error occured while updating timezone";

              this.$refs.updateBtn.disabled = false;
              this.$refs.updateBtn.innerHTML = "Update";
            }, 1000);
          }
        })
        .catch(err => console.log(err));
    }
  }
};
</script>

<style>
</style>
